<template>
    <div class="access-choice">
        <div class="row">
            <div class="col-12">
                <h3 class="text-center"> Recupere seu acesso </h3>
            </div>
            <div class="col-12 mt-3 mb-3 text-justify">
                Escolha o endereço de e-mail para o qual você quer que o código de acesso seja enviado. É importante que você tenha acesso a este endereço,
                pois é nele que você vai resgatar o código que usará para continuar o processo de recuperação. 
            </div>
        </div>
        <div class="choices d-flex">
            <label :key="'choice-item-' + index" :for="'choice-item-' + index" class="choice-item" v-for="(access, index) in accesses" :data-target="'choice-item-' + index">
                <div class="row">
                    <div class="col-md-1">
                        <input v-on:change="changeChoice(index)" type="checkbox" :id="'choice-item-' + index" class="form-check-input"/>
                    </div>
                    <div class="col-md-11">
                        @{{ stripEmail(access.email) }}
                    </div>
                </div>
            </label>
        </div>
        <div class="row">
            <div class="col-12">
                <button v-if="!loading" class="form-control btn-success btn-lg" v-on:click="submit"> ENVIAR CÓDIGO </button>
                <button v-else class="form-control btn-success btn-lg d-flex justify-content-center align-items-center" type="button" disabled>
                    <div class="spinner-border text-dark" role="status"></div>
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue'

export default Vue.extend({
    data() {
        return {
            current: undefined,
            loading: false
        }
    },
    mounted() {
        this.current = this.accesses[0]
    },
    props: {
        accesses: {
            required: true
        },
    },
    methods: {
        async submit() {
            try {
                this.loading = true
                await axios.get(`/account/recover/send/${this.current.token}`)
                this.$emit('success', this.current)
            } catch (error) {
                this.$emit('error', error.response.data.message)
            } finally {
                this.loading = false
            }
        },
        changeChoice(index) {
            const containers = document.querySelectorAll('.choice-item')
            containers.forEach((el) => el.classList.remove('active'))

            const all = document.querySelectorAll('.choice-item input[type=checkbox]')
            all.forEach((el) => el.value = false)

            const choice = document.getElementById(`choice-item-${index}`)
            choice.value = true

            const choiceContainer = document.querySelector(`label[data-target='choice-item-${index}']`)
            choiceContainer.classList.add('active')

            this.currentChoosedAccess = this.accesses[index]
        },
        stripEmail(email) {
            return email.split(' ')[0]
        }
    }
})
</script>

<style scoped>
    .np {
        padding: 0px !important;
    }

    .nm {
        margin: 0px !important;
    }

    .form-control {
        font-size: 16px;
    }
    
    .text-justify {
        text-align: justify;
    }
</style>